import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PartnerFormPage from "./PartnerFormPage"
import Partner from "models/PartnerModel";

const PartnerEdit = () => {
  const [partnerData, setPartnerData] = useState({})

  const params = useParams();

  const getPartnerData = async (id) => {
    return await Partner.getById(id);
  }

  useEffect(() => {
    (async () => {
      let result = await getPartnerData(params.id)
      setPartnerData(result)
    })()
  }, [params])


  return (
    <PartnerFormPage partnerData={partnerData}></PartnerFormPage>
  )
}

export default PartnerEdit;
